module.exports = __webpack_public_path__ + "static/media/moisture.74b28f74.svg";